<template>
  <!--
    移动端按钮。

    ★ 独立使用：一行占满，样式与 el-button 对齐（el-type 透传给 el-button）。
    ★ 放在 MobileButtonGroup 里：挂载时自动向父组件注册，由父组件统一决定排版；
      本组件保留渲染（父组件在分组模式下隐藏它），点击时由父组件回调 handleClick，
      所以 @click 监听始终挂在调用方页面这一层，不会因重排丢失。
  -->
  <div class="mobile-button">
    <el-button :type="elType || ''" :disabled="disabled" @click="handleClick">
      <yq-icon v-if="icon" class="button-icon" :name="icon"/>
      <span class="button-label"><slot/></span>
    </el-button>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";

let buttonSeed = 0;

export default {
  emits: ["click"],
  props: {
    label: {default: ""},              // 兜底文案；默认从默认插槽取
    icon: {default: ""},               // 图标（YqIcon name）
    elType: {default: ""},             // 与 el-button 的 type 对齐
    disabled: {default: false},
  },
  name: "MobileButton",
  components: {
    YqIcon
  },
  data() {
    return {
      uid: "mobile_button_" + (++buttonSeed),
      slotLabel: "",
      inGroup: false,
    };
  },
  created() {
    this.slotLabel = this.readSlotLabel();
    // 向父按钮组注册；不在按钮组里时不注册，按普通按钮显示
    const parent = this.$parent;
    if (parent && typeof parent.registerButton === "function") {
      this.inGroup = true;
      parent.registerButton(this.registration());
    }
  },
  beforeUnmount() {
    const parent = this.$parent;
    if (parent && typeof parent.unregisterButton === "function") {
      parent.unregisterButton(this.uid);
    }
  },
  methods: {
    /** 从默认插槽读取按钮文案，供按钮组重排时展示 */
    readSlotLabel() {
      if (this.label) {
        return this.label;
      }
      const slotContent = this.$slots.default ? this.$slots.default() : [];
      return slotContent
          .map(vnode => typeof vnode.children === "string" ? vnode.children : "")
          .join("")
          .trim();
    },
    /** 注册给按钮组的元数据 */
    registration() {
      return {
        uid: this.uid,
        label: this.label || this.slotLabel,
        icon: this.icon,
        elType: this.elType,
        disabled: this.disabled,
        click: this.handleClick,
      };
    },
    /** 按钮组点击重排后的按钮时回调到这里，保证 @click 事件照常抛出 */
    handleClick(event) {
      if (this.disabled) {
        return;
      }
      this.$emit("click", event);
    },
  }
};
</script>

<style lang="scss" scoped>
.mobile-button{
  width: 100%;
  :deep(.el-button){
    width: 100%;
    height: 50px;
    font-size: var(--yq-font-size-large-mobile);
    padding: 10px;
    .button-icon{
      margin-right: 6px;
      font-size: 18px;
      vertical-align: middle;
    }
    .button-label{
      vertical-align: middle;
    }
  }
}
</style>
